/* eslint-disable */
export const planToIndex = (plans, plan) => plans.findIndex(p => p.value === plan.value);
